<template>
  <v-dialog v-model="show" width="450" @click:outside="onClickCancel">
    <v-card>
      <div class="header-icon-wrapper">
        <v-icon color="blue darken-2">mdi-check-circle-outline</v-icon>
      </div>
      <div class="wrapper-text">
        <v-card-text> {{ $t("assignProcessText") }}</v-card-text>
      </div>
      <div class="process-main-actions">
        <v-btn outlined large color="primary" @click="onClickCancel">
          {{ $t("cancel") }}</v-btn
        >
        <v-btn
          large
          color="primary"
          @click="onClickAssignProcess"
          :disabled="isAssignmentInProgress"
          :loading="isAssignmentInProgress"
          >{{ $t("ok") }}</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import AssignProcessDialog from "./mixin/AssignProcessDialog";

export default {
  mixins: [AssignProcessDialog]
};
</script>

<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.wrapper-text {
  text-align: center;
  color: $primaryColor;
}
.process-main-actions {
  text-align: center;
  padding-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/components/AssignProcessDialog.vue